import * as React from "react";

const CalendarIcon = ({ color = "#596375", ...props }: React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.5 8.83342H2.5M13.3333 2.16675V5.50008M6.66667 2.16675V5.50008M6.5 18.8334H13.5C14.9001 18.8334 15.6002 18.8334 16.135 18.5609C16.6054 18.3212 16.9878 17.9388 17.2275 17.4684C17.5 16.9336 17.5 16.2335 17.5 14.8334V7.83342C17.5 6.43328 17.5 5.73322 17.2275 5.19844C16.9878 4.72803 16.6054 4.34558 16.135 4.1059C15.6002 3.83341 14.9001 3.83341 13.5 3.83341H6.5C5.09987 3.83341 4.3998 3.83341 3.86502 4.1059C3.39462 4.34558 3.01217 4.72803 2.77248 5.19844C2.5 5.73322 2.5 6.43328 2.5 7.83341V14.8334C2.5 16.2335 2.5 16.9336 2.77248 17.4684C3.01217 17.9388 3.39462 18.3212 3.86502 18.5609C4.3998 18.8334 5.09987 18.8334 6.5 18.8334Z"
      stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    />
  </svg>

);

export default CalendarIcon;